<template>
  <div class="otp" role="group" aria-label="SMS code">
    <input
      v-for="(digit, i) in digits"
      :key="i"
      :ref="'box' + i"
      class="box"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      :value="digit"
      @input="onInput($event, i)"
      @keydown="onKey($event, i)"
      @paste.prevent="onPaste"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return { digits: ['', '', '', '', '', ''] }
  },
  watch: {
    value(next) {
      const clean = String(next || '').replace(/\D/g, '').slice(0, 6)
      this.digits = Array.from({ length: 6 }, (_, i) => clean[i] || '')
    },
  },
  mounted() {
    this.focusBox(0)
  },
  methods: {
    code() {
      return this.digits.join('')
    },
    emitCode() {
      const code = this.code()
      this.$emit('input', code)
      if (code.length === 6) this.$emit('complete', code)
    },
    focusBox(i) {
      const box = this.$refs['box' + i]
      const el = Array.isArray(box) ? box[0] : box
      if (el && el.focus) el.focus()
    },
    onInput(event, i) {
      const raw = String(event.target.value || '').replace(/\D/g, '')
      if (raw.length > 1) {
        this.fill(raw)
        event.target.value = this.digits[i]
        return
      }
      this.$set(this.digits, i, raw.slice(-1))
      event.target.value = this.digits[i]
      if (this.digits[i] && i < 5) this.focusBox(i + 1)
      this.emitCode()
    },
    onKey(event, i) {
      if (event.key === 'Backspace' && !this.digits[i] && i > 0) {
        this.$set(this.digits, i - 1, '')
        this.focusBox(i - 1)
        this.emitCode()
      }
    },
    onPaste(event) {
      const text = (event.clipboardData && event.clipboardData.getData('text')) || ''
      this.fill(text)
    },
    fill(text) {
      const clean = String(text).replace(/\D/g, '').slice(0, 6)
      this.digits = Array.from({ length: 6 }, (_, i) => clean[i] || '')
      this.focusBox(Math.min(clean.length, 5))
      this.emitCode()
    },
  },
}
</script>

<style scoped>
.otp {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}
.box {
  width: 48px;
  height: 56px;
  border: 1.5px solid #E5E7EB;
  border-radius: 12px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #002855;
  font-family: inherit;
  background: #fff;
}
.box:focus {
  outline: none;
  border-color: #FFA800;
}
</style>
